import { MatchListType } from '@okletsplay/core';
import { createEntityAdapter } from '@reduxjs/toolkit';
import { MatchEntity } from 'app/interfaces/entity';
import { MatchesState } from './interfaces';
import { MatchStoreStatus } from './enums';

export const entityAdapter = createEntityAdapter<MatchEntity>({
  selectId: (data) => data.id,
});

export const FEATURED_MATCHES_COUNT = 12;

export const initialState: MatchesState = entityAdapter.getInitialState({
  status: {
    [MatchStoreStatus.Loading]: [],
    [MatchStoreStatus.Creating]: [],
    [MatchStoreStatus.Updating]: [],
    [MatchStoreStatus.MatchCountLoading]: [],
  },
  pagination: {
    [MatchListType.Featured]: { limit: FEATURED_MATCHES_COUNT, offset: 0, total: 0, reload: true },
  },
});
